import { withContext } from 'common/utils/context';
import EditorContext, { editorContext, normalizeSigners } from './editor-context';

export { editorContext, normalizeSigners };

export default EditorContext;

export const withEditorContext = withContext(editorContext, 'editorContext');
